import { GlobalMenu } from '@components';
import { IItemList } from '@components/GlobalMenu/GlobalMenu';
import { AssetContext } from '@pages/Asset/Asset.query';
import { checkDevice } from '@store/redux/features/mobile/mobileSelectors';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Container } from './TagsMenu.styles';

const TagsMenu = () => {
  const { removeTags, openTagModal, showAllTags, equipmentQuery } =
    useContext(AssetContext);

  const { tags = [] } = equipmentQuery?.data || {};
  const { isMobile } = useSelector(checkDevice());
  const addTagItem: IItemList = {
    label: 'Add tag',
    iconName: 'tag',
    onClick: () => {
      openTagModal.set(true);
    },
  };
  const removeTagsItem: IItemList = {
    label: 'Remove Tags',
    iconName: 'delete',
    disabled: tags.length === 0,
    onClick: () => {
      removeTags.set(true);
    },
  };
  const showAllItem: IItemList = {
    label: 'Show All',
    iconName: 'expand-all',
    onClick: () => {
      showAllTags.set(true);
    },
  };
  const showLessItem: IItemList = {
    label: 'Show less',
    iconName: 'collapse-all',
    onClick: () => {
      showAllTags.set(false);
    },
  };

  function getItems() {
    if (isMobile) {
      return [
        addTagItem,
        removeTagsItem,
        showAllTags.get() ? showLessItem : showAllItem,
      ];
    }

    return [addTagItem, removeTagsItem];
  }

  return (
    <Container>
      <GlobalMenu align="end" title="Options" itemList={getItems()} />
    </Container>
  );
};

export { TagsMenu };
